import  { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { gotAFile, requestUpload, allFilesComplete, albumListRequested } from '../actions/uploadController-actions';
//mport { albumListRequested } from '../../album-view/actions/album-actions';




class UploadController extends Component {

	componentDidMount(){
		this.props.albumListRequested();
	}
	componentDidUpdate(prevProps) {

		const { filesInProcess, requestUpload, isPaused, allFilesComplete, uploadInProcess, albumListRequested, uploadAlbumId } = this.props;


		if (filesInProcess.length >0 && (prevProps.filesInProcess.length === 0 || prevProps.filesInProcess.length > filesInProcess.length || prevProps.isPaused)&&!isPaused && !uploadInProcess){
			requestUpload(filesInProcess[0], uploadAlbumId);
		}
		if (filesInProcess.length === 0 && prevProps.filesInProcess.length >0){
		//	albumListRequested();
			
			setTimeout(function(){allFilesComplete();},2000);
			
		}
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.albums.length != this.props.albums.length){
			this.props.albumListRequested();
		}
		}

	render() {
		
		return null;
	}
}
UploadController.propTypes = {
	filesInProcess: PropTypes.array,
	gotAFile: PropTypes.func,
	requestUpload: PropTypes.func,
	uploadInProgress: PropTypes.bool,
	isPaused: PropTypes.bool,
	allFilesComplete: PropTypes.func,
	uploadInProcess: PropTypes.bool,
	albumListRequested: PropTypes.func,
	requestSnapfishCollections: PropTypes.func,
	uploadAlbumId: PropTypes.number,
	albums: PropTypes.array
	
};

const mapStateToProps = state => {
	return {
		filesInProcess: state.uploadController.filesInProcess,
		uploadInProgress: state.uploadController.uploadInProgress,
		isPaused: state.uploadController.isPaused,
		uploadInProcess: state.uploadController.uploadInProcess,
		uploadAlbumId: state.uploadController.uploadAlbumId,
		albums: state.albumList.albums
	};
};

const mapDispatchToProps = dispatch => {
	return {
		gotAFile: (file) => dispatch(gotAFile(file)),
		requestUpload: (file, uploadAlbumId) => dispatch(requestUpload(dispatch, file, uploadAlbumId)),
		allFilesComplete: () => dispatch(allFilesComplete()),
		albumListRequested: (offset = 0) => {
			dispatch(albumListRequested(dispatch, offset, false, 100, true));
		},
		
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadController);



// WEBPACK FOOTER //
// ./src/uploadController/components/uploadController-container.jsx